import { render, staticRenderFns } from "./tickets-tab.vue?vue&type=template&id=3663ef38&scoped=true&"
import script from "./tickets-tab.vue?vue&type=script&lang=js&"
export * from "./tickets-tab.vue?vue&type=script&lang=js&"
import style0 from "./tickets-tab.vue?vue&type=style&index=0&id=3663ef38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3663ef38",
  null
  
)

export default component.exports